import VideoCard from '../../components/VideoCard';
import VideoCardMobile from '../../components/VideoCardMobile';
import FilterBar from '../../components/FilterBar/FilterBar';
import LoadingIndicator from '../../components/LoadingIndicator';
import { useVideoList } from './useVideoList';
import { SessionManager } from '../../utils/SessionManager';
import styles from './VideoList.module.css';

const VideoList = () => {
  const {
    videoData,
    isLoading,
    isMobile,
    videoSource,
    externalError,
    handleVisibilityChange,
    sortOrder,
    setSortOrder,
    specialty,
    setSpecialty,
    specialtyOptions,
    procedure,
    setProcedure,
  } = useVideoList();

  const activeSession = SessionManager.getActiveSession();
  const currentUserId = activeSession ? activeSession.userId : null;

  return (
    <div className={styles['video-list-page']}>
      <FilterBar
        sortOrder={sortOrder}
        onSortOrderChange={setSortOrder}
        specialty={specialty}
        onSpecialtyChange={setSpecialty}
        specialtyOptions={specialtyOptions}
        procedure={procedure}
        onProcedureChange={setProcedure}
      />

      <div className={styles['video-list-container']}>
        {videoData.length > 0 ? (
          videoData.map((video) => {
            // 外部動画の場合はアクションを非表示にする
            if (video.isExternal) {
              return (
                <div className={styles['video-card-wrapper']} key={video.id}>
                  {isMobile
                    ? <VideoCardMobile
                        video={video}
                        hideVisibilityToggle={true}
                      />
                    : <VideoCard
                        video={video}
                        hideVisibilityToggle={true}
                      />
                  }
                </div>
              );
            }

            // 自分がアップロードした動画かどうかを判定
            const isOwnVideo = video.uploader_id === currentUserId;
            // 非公開動画で自分のアップロードかどうかによって切り替えボタンの表示を制御
            const hideVisibilityToggle = !(isOwnVideo && video.visibility === 'private');

            return (
              <div className={styles['video-card-wrapper']} key={video.id}>
                {isMobile
                  ? <VideoCardMobile
                      video={video}
                      hideVisibilityToggle={hideVisibilityToggle}
                      onVisibilityChange={handleVisibilityChange}
                    />
                  : <VideoCard
                      video={video}
                      hideVisibilityToggle={hideVisibilityToggle}
                      onVisibilityChange={handleVisibilityChange}
                    />
                }
              </div>
            );
          })
        ) : specialty && videoSource === 'external' ? (
          <p className={styles['video-list-empty']} data-testid="video-list__empty-external-filtered">
            診療科で絞り込み中は院外の動画は表示されません。
          </p>
        ) : specialty ? (
          <p className={styles['video-list-empty']} data-testid="video-list__empty-filtered">
            「{specialty}」の動画はありません。
          </p>
        ) : externalError && videoSource !== 'internal' ? (
          <p className={styles['video-list-empty']}>外部動画の取得に失敗しました。再読み込みしてください。</p>
        ) : (
          <p className={styles['video-list-empty']}>動画がありません。</p>
        )}
      </div>
      {/* 読み込み中の表示 */}
      {isLoading && <LoadingIndicator className={styles['video-list-loading-indicator']} />}
    </div>
  );
};

export default VideoList;
